import React, { useCallback, useRef } from 'react';

import {
  TRANSACTION_TAB_INDEX,
  useFileEntryViewer,
} from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/store/fileEntryViewer.store';

import ApiButton from '../../Elements/ApiButton/ApiButton';
import { useTreatments } from '../../store/treatments.store';
import { BaseFormOption } from '../TreatmentForm/BaseForm/BaseForm';
import { CheckPaymentFormOption } from '../TreatmentForm/CheckPaymentForm/CheckPaymentForm';
import { PaidBillFormOption } from '../TreatmentForm/PaidBillForm/PaidBillForm';
import { UnpaidBillFormOption } from '../TreatmentForm/UnpaidBillForm/UnpaidBillForm';

const CreateTreatment = () => {
  const buttonRef = useRef(null);
  const { setForm } = useTreatments();
  const { setActiveTab } = useFileEntryViewer();

  const handleClick = useCallback(() => {
    const form = FORM_TYPES.Base;

    setForm(form);
    setActiveTab(TRANSACTION_TAB_INDEX);
  }, [setActiveTab, setForm]);

  return (
    <React.Fragment>
      <div className="fileActionsContainer">
        <ApiButton
          id={''}
          className={'tw-mr-0 tw-leading-none'}
          buttonRef={buttonRef}
          onClick={handleClick}
        />
      </div>
    </React.Fragment>
  );
};

export default CreateTreatment;

export const FORM_TYPES = {
  Base: BaseFormOption,
  Bill: UnpaidBillFormOption,
  Expense: PaidBillFormOption,
  Check: CheckPaymentFormOption,
};
